/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateMeRequestUserFromJSON, UpdateMeRequestUserToJSON } from './UpdateMeRequestUser';
export function UpdateMeRequestFromJSON(json) {
    return UpdateMeRequestFromJSONTyped(json, false);
}
export function UpdateMeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        user: !exists(json, 'user') ? undefined : UpdateMeRequestUserFromJSON(json['user'])
    };
}
export function UpdateMeRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        user: UpdateMeRequestUserToJSON(value.user)
    };
}
